import React from 'react'
import {Button} from "@material-ui/core";

import {
  PopupTitle,
  PopupContainer,
  PopupDescription,
  PopupButtonsContainer
} from "../HygienistJobDetails.styles";

interface SuccessActionProps {
  title: string
  description: string
  onConfirm: () => void
}

const SuccessAction = ({
  onConfirm,
  title,
  description
}: SuccessActionProps) => {
  return (
    <PopupContainer>
      <PopupTitle>{title}</PopupTitle>
      <PopupDescription>{description}</PopupDescription>
      <PopupButtonsContainer>
        <Button
          variant="contained"
          onClick={onConfirm}
          color="primary"
          size="large"
          id="review-button"
          className="bigButtonInNewStyle"
        >
          OK
        </Button>
      </PopupButtonsContainer>
    </PopupContainer>
  )
}

export default SuccessAction;
